import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import herobg from "../images/stories/herobg.png"
import LogoBlack from "../images/logoblack.png"
import LogoWhite from "../images/logo.png"
import "./header.css"

let heroBg = {
  backgroundImage: "url(" + herobg + ")",
}

const HeaderStories = () => (
  <div className="headerStories" style={heroBg}>
    <header>
      <div className="header flex justify-content">
        <a href="/" target="_blank">
          <img src={LogoWhite} alt="Logo" />
        </a>
        <ul>
          <li>
            <a
              href="https://greatguides.com/adventures"
              target="_blank"
              rel="noopener noreferrer"
            >
              Adventures
            </a>
          </li>
          <li>
            <a
              href="https://greatguides.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Guides
            </a>
          </li>
          <li>
            <Link to="/team/">Team</Link>
          </li>
        </ul>
      </div>
    </header>
    <div className="hero-section">
      <div className="container">
        <h1>Great stories</h1>
        <p>
          Inspirational conservation and social projects. Most can be met if
          traveling.
        </p>
        <div className="links doublelinks">
          <a href="#stories" className="btn orange-btn">
            Read Stories
          </a>
          <a href="/" className="btn btn-transparent">
            Find Adventure
          </a>
        </div>
      </div>
    </div>
  </div>
)

HeaderStories.propTypes = {
  siteTitle: PropTypes.string,
}

HeaderStories.defaultProps = {
  siteTitle: ``,
}

export default HeaderStories
